import { FC } from 'react';
import { Button } from '../../../../../components-v2/Button';
import { FutureMeetingIcon } from '../../../../svgs/icons/FutureMeetingIcon';
import { AgentRow, AgentRowIcon } from '../../AgentRow';

export const DashboardMeetingPrepErrorRow: FC<{ onRetry: () => void }> = ({ onRetry }) => (
	<AgentRow
		icon={
			<AgentRowIcon>
				<FutureMeetingIcon />
			</AgentRowIcon>
		}
		title='Meeting Prep'
		detail='We couldn’t load your meeting briefs.'
		action={
			<Button size='sm' variant='secondary' onClick={onRetry}>
				Try again
			</Button>
		}
	/>
);
